import React from 'react';

// or your appropriate styles
import { MY_EVENTS_ROUTE } from 'routes/events/list';
import { Link } from 'ui';

import s from './BackLink.module.scss';

const BackLink: React.FC = () => {
  return (
    <Link
      to={MY_EVENTS_ROUTE}
      icon="arrowLeft"
      label="My Events"
      labelType="h6"
      className={s.backLink}></Link>
  );
};

export default BackLink;
